(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1 & 3. IntersectionObserver for .fm-reveal and .fm-stagger ── */
  function makeObserver(opts) {
    return new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, opts);
  }

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      obs.unobserve(entry.target);
    });
  }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });

  /* Observe explicitly marked elements */
  document.querySelectorAll('.fm-reveal, .fm-stagger').forEach(function (el) {
    if (reducedMotion) { el.classList.add('is-visible'); return; }
    obs.observe(el);
  });

  /* Auto scroll-reveal: every shopify section except the first (hero) */
  if (!reducedMotion) {
    var sections = document.querySelectorAll('.shopify-section');
    sections.forEach(function (section, i) {
      if (i === 0) return;
      if (section.classList.contains('fm-reveal')) return;
      section.classList.add('fm-reveal');
      obs.observe(section);
    });
  }

  /* ── 5. Word reveal ──────────────────────────────────────────────── */
  function applyWordReveal(el) {
    var raw = el.textContent || '';
    if (!raw.trim()) return;
    var words = raw.trim().split(/\s+/);
    el.innerHTML = words.map(function (word, i) {
      var delay = (i * 0.07).toFixed(2);
      return '<span class="fm-word-wrap" aria-hidden="true"><span class="fm-word-inner" style="transition-delay:' + delay + 's">' + word + '</span></span>';
    }).join(' ');
    el.setAttribute('aria-label', raw.trim());

    var wordObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('fm-words-visible');
        wordObs.unobserve(entry.target);
      });
    }, { threshold: 0.3 });
    wordObs.observe(el);
  }

  /* Apply to [data-fm-words] elements */
  document.querySelectorAll('[data-fm-words]').forEach(function (el) {
    if (reducedMotion) return;
    if (el.innerHTML.indexOf('<') !== -1) return;
    applyWordReveal(el);
  });

  /* Auto-apply word reveal to the first heading on the page */
  if (!reducedMotion) {
    var heroSection = document.querySelector('.shopify-section:first-child');
    if (heroSection) {
      var firstHeading = heroSection.querySelector('h1, h2');
      if (firstHeading && firstHeading.innerHTML.indexOf('<') === -1) {
        applyWordReveal(firstHeading);
      }
    }
  }

  /* ── Mega menu trigger ───────────────────────────────────────────── */
  (function () {
    var panel = document.getElementById('fm-mega-panel');
    var backdrop = document.getElementById('fm-mega-backdrop');
    if (!panel || !backdrop) return;

    /* Injecteer "Alle producten" knop als eerste item in de inline nav */
    var nav = document.querySelector('.header__inline-menu .list-menu');
    if (nav) {
      var li = document.createElement('li');
      li.className = 'list-menu__item';

      var btn = document.createElement('button');
      btn.className = 'fm-mega-trigger list-menu__item--link link link--text';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', 'fm-mega-panel');
      btn.innerHTML = 'Alle producten <svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      li.appendChild(btn);
      nav.insertBefore(li, nav.firstChild);

      /* Positie panel onder de header */
      function positionPanel() {
        var header = document.querySelector('.header-wrapper');
        if (header) {
          var rect = header.getBoundingClientRect();
          panel.style.top = (rect.bottom + 8) + 'px';
        }
      }

      function openPanel() {
        positionPanel();
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        backdrop.classList.add('is-open');
        btn.classList.add('is-active');
        btn.setAttribute('aria-expanded', 'true');
      }

      function closePanel() {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        backdrop.classList.remove('is-open');
        btn.classList.remove('is-active');
        btn.setAttribute('aria-expanded', 'false');
      }

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        panel.classList.contains('is-open') ? closePanel() : openPanel();
      });

      backdrop.addEventListener('click', closePanel);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closePanel();
      });

      /* Sluit als je buiten het panel klikt */
      panel.addEventListener('click', function (e) { e.stopPropagation(); });
    }
  })();

  /* ── Announcement ticker ─────────────────────────────────────────── */
  (function () {
    function initTicker() {
      var bar = document.querySelector('.announcement-bar');
      if (!bar) return;

      /* Haal teksten op uit de Shopify blocks (voor slider geïnitialiseerd) */
      var texts = [];
      bar.querySelectorAll('[data-announcement-bar-block] p, .announcement-bar__message').forEach(function (el) {
        var t = el.textContent.trim();
        if (t && texts.indexOf(t) === -1) texts.push(t);
      });
      /* Fallback: lees uit de section JSON die Dawn in de DOM zet */
      if (!texts.length) {
        bar.querySelectorAll('p, [class*="message"]').forEach(function (el) {
          var t = el.textContent.trim();
          if (t.length > 3 && texts.indexOf(t) === -1) texts.push(t);
        });
      }
      if (!texts.length) return;

      /* Verberg alles in de bar behalve onze ticker */
      Array.from(bar.children).forEach(function (child) {
        if (!child.classList.contains('fm-ticker-wrap')) child.style.display = 'none';
      });

      /* Verwijder vorige ticker */
      var prev = bar.querySelector('.fm-ticker-wrap');
      if (prev) prev.remove();

      /* Bouw 2 identieke sets voor naadloze loop */
      function makeSet() {
        var frag = document.createDocumentFragment();
        texts.forEach(function (text) {
          var item = document.createElement('span');
          item.className = 'fm-ticker-item';
          item.textContent = text;
          frag.appendChild(item);
        });
        return frag;
      }

      var inner = document.createElement('div');
      inner.className = 'fm-ticker-inner';
      inner.appendChild(makeSet());
      inner.appendChild(makeSet());

      var wrap = document.createElement('div');
      wrap.className = 'fm-ticker-wrap';
      wrap.appendChild(inner);
      bar.appendChild(wrap);

      /* rAF-loop: meet halfWidth, animeer op 55px/s */
      requestAnimationFrame(function () {
        var halfWidth = inner.scrollWidth / 2;
        if (halfWidth <= 0) return;
        var speed = 32;
        var offset = 0;
        var lastTs = null;

        function tick(ts) {
          if (lastTs !== null && !wrap._paused) {
            offset += speed * (ts - lastTs) / 1000;
            if (offset >= halfWidth) offset -= halfWidth;
            inner.style.transform = 'translateX(-' + offset.toFixed(2) + 'px)';
          }
          lastTs = ts;
          requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);

        wrap.addEventListener('mouseenter', function () { wrap._paused = true; });
        wrap.addEventListener('mouseleave', function () { wrap._paused = false; });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(initTicker, 150); });
    } else {
      setTimeout(initTicker, 150);
    }
  })();

  /* ── 4. Parallax ─────────────────────────────────────────────────── */
  if (!reducedMotion) {
    var parallaxEls = Array.from(document.querySelectorAll('[data-fm-parallax]'));

    /* Auto-add parallax to the hero image if no explicit target */
    if (parallaxEls.length === 0) {
      var heroImg = document.querySelector(
        '.shopify-section:first-child .media, ' +
        '.shopify-section:first-child .hero-two-column__image-wrap, ' +
        '.shopify-section:first-child .image-with-text__media'
      );
      if (heroImg) {
        heroImg.dataset.fmParallax = '0.07';
        parallaxEls = [heroImg];
      }
    }

    if (parallaxEls.length > 0) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          parallaxEls.forEach(function (el) {
            var speed = parseFloat(el.dataset.fmParallax) || 0.07;
            var rect = el.getBoundingClientRect();
            var centerOffset = rect.top + rect.height / 2 - window.innerHeight / 2;
            el.style.transform = 'translateY(' + (centerOffset * speed).toFixed(2) + 'px)';
          });
          ticking = false;
        });
      }, { passive: true });
    }
  }
})();
